export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/admin/organisations', 'admin.organisations')
    .when('/admin/organisations/:orgId/info', 'admin.organisation-info')
    .when('/admin/organisations/:orgId/financials', 'admin.organisation-financials')
    .when('/admin/organisations/:orgId/bicycles', 'admin.organisation-bicycles')
    .when('/admin/organisations/:orgId/bicycles/:id', 'admin.organisation-bicycle-info')
    .when('/admin/organisations/:orgId/bicycle-groups', 'admin.organisation-groups-list')
    .when('/admin/organisations/:orgId/bicycle-groups/:groupId/bicycles', 'admin.organisation-group-bicycles')
    .when('/admin/organisations/:orgId/service-bookings', 'admin.organisation-requests')
    .when('/admin/organisations/:orgId/service-bookings/:id', 'admin.organisation-request-info')
    .when('/admin/organisations/:orgId/service-bookings/:id/reporting', 'admin.organisation-request-reporting')
    .when('/admin/organisations/:orgId/service-bookings/:id/reassign', 'admin.organisation-reassign-request')
    .when('/admin/organisations/:orgId/managers', 'admin.organisation-managers')
    .when('/admin/organisations/:orgId/dealers', 'admin.organisation-dealers')
    .when('/admin/organisations/:orgId/dealers/:id', 'admin.organisation-dealer-info')
    .when('/admin/organisations/:orgId/services', 'admin.organisation-services')

    .within('admin')

    .segment('organisations', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [{
        label: 'admin.breadcrumb.organisations'
      }],
      template: '<admin-organisations-list-page></admin-organisations-list-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-organisations-list.module" */ "./list/admin-organisations-list.module");
      }
    })

    .segment('organisation-info', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.organisations',
          url: '/admin/organisations'
        },
        {
          label: 'admin.breadcrumb.organisation_info'
        }
      ],
      template: '<admin-organisation-info-page></admin-organisation-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-organisation-info.module" */ "./info/admin-organisation-info.module");
      }
    })

    .segment('organisation-financials', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.organisations',
          url: '/admin/organisations'
        },
        {
          label: 'admin.breadcrumb.organisation_info'
        }
      ],
      template: '<admin-organisation-financials-page></admin-organisation-financials-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-organisation-financials.module" */ "./financials/admin-organisation-financials.module");
      }
    })

    .segment('organisation-bicycles', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.organisations',
          url: '/admin/organisations'
        },
        {
          label: 'admin.breadcrumb.organisation_info'
        }
      ],
      template: '<admin-organisation-bicycles-list-page></admin-organisation-bicycles-list-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-organisations-bicycles-list.module" */ "./bicycles-list/admin-organisations-bicycles-list.module");
      }
    })

    .segment('organisation-bicycle-info', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.organisations',
          url: '/admin/organisations'
        },
        {
          label: 'admin.breadcrumb.organisation_info',
          url: '/admin/organisations/:orgId/bicycles',
          params: {
            orgId: ':orgId'
          }
        },
        {
          label: 'admin.breadcrumb.bicycle_info'
        }
      ],
      template: '<admin-organisations-bicycle-info-page></admin-organisations-bicycle-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-organisations-bicycle-info.module" */ "./bicycles-info/admin-organisations-bicycle-info.module");
      }
    })

    .segment('organisation-groups-list', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.organisations',
          url: '/admin/organisations'
        },
        {
          label: 'admin.breadcrumb.organisation_info'
        }
      ],
      template: '<admin-organisations-bicycle-groups-page></admin-organisations-bicycle-groups-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-organisations-bicycle-groups.module" */ "./bicycles-groups/admin-organisations-bicycle-groups.module");
      }
    })

    .segment('organisation-group-bicycles', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.organisations',
          url: '/admin/organisations'
        },
        {
          label: 'admin.breadcrumb.organisation_info',
          url: '/admin/organisations/:orgId/bicycle-groups',
          params: {
            orgId: ':orgId'
          }
        },
        {
          label: 'admin.breadcrumb.bicycles'
        }
      ],
      template: '<admin-organisation-group-bicycles-list-page></admin-organisation-group-bicycles-list-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-organisations-group-bicycles-list.module" */ "./group-bicycles-list/admin-organisations-group-bicycles-list.module");
      }
    })

    .segment('organisation-requests', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.organisations',
          url: '/admin/organisations'
        },
        {
          label: 'admin.breadcrumb.organisation_info'
        }
      ],
      template: '<admin-organisation-requests-list-page></admin-organisation-requests-list-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-organisations-requests-list.module" */ "./requests-list/admin-organisations-requests-list.module");
      }
    })

    .segment('organisation-request-info', {
      access: {requireLogin: true, hasAuthority: 'ADMIN', isRequest: true},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.organisations',
          url: '/admin/organisations'
        },
        {
          label: 'admin.breadcrumb.organisation_info',
          url: '/admin/organisations/:orgId/service-bookings',
          params: {
            orgId: ':orgId'
          }
        },
        {
          label: 'admin.breadcrumb.service_booking_info'
        }
      ],
      template: '<admin-organisation-request-info-page></admin-organisation-request-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-organisations-request-info.module" */ "./request-info/admin-organisations-request-info.module");
      }
    })

    .segment('organisation-request-reporting', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.organisations',
          url: '/admin/organisations'
        },
        {
          label: 'admin.breadcrumb.organisation_info',
          url: '/admin/organisations/:orgId/service-bookings',
          params: {
            orgId: ':orgId'
          }
        },
        {
          label: 'admin.breadcrumb.service_booking_info',
          url: '/admin/organisations/:orgId/service-bookings/:id',
          params: {
            orgId: ':orgId',
            id: ':id'
          }
        },
        {
          label: 'admin.breadcrumb.booking_reporting',
        }
      ],
      template: '<admin-organisation-request-reporting-page></admin-organisation-request-reporting-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-organisation-request-reporting.module" */ "./request-reporting/admin-organisation-request-reporting.module");
      }
    })

    .segment('organisation-reassign-request', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.organisations',
          url: '/admin/organisations'
        },
        {
          label: 'admin.breadcrumb.organisation_info',
          url: '/admin/organisations/:orgId/service-bookings',
          params: {
            orgId: ':orgId'
          }
        },
        {
          label: 'admin.breadcrumb.service_booking_info',
          url: '/admin/organisations/:orgId/service-bookings/:id',
          params: {
            orgId: ':orgId',
            id: ':id'
          }
        },
        {
          label: 'admin.breadcrumb.booking_reassign',
        }
      ],
      template: '<admin-organisations-reassign-request-page></admin-organisations-reassign-request-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-organisations-reassign-request.module" */ "./reassign-request/admin-organisations-reassign-request.module");
      }
    })

    .segment('organisation-managers', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.organisations',
          url: '/admin/organisations'
        },
        {
          label: 'admin.breadcrumb.organisation_info'
        }
      ],
      template: '<admin-organisation-managers-page></admin-organisation-managers-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-organisation-managers.module" */ "./managers/admin-organisation-managers.module");
      }
    })

    .segment('organisation-dealers', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.organisations',
          url: '/admin/organisations'
        },
        {
          label: 'admin.breadcrumb.organisation_info'
        }
      ],
      template: '<admin-organisation-dealers-page></admin-organisation-dealers-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-organisation-dealers.module" */ "./dealers/admin-organisation-dealers.module");
      }
    })

    .segment('organisation-dealer-info', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.organisations',
          url: '/admin/organisations'
        },
        {
          label: 'admin.breadcrumb.organisation_info',
          url: '/admin/organisations/:orgId/dealers',
          params: {
            orgId: ':orgId'
          }
        },
        {
          label: 'admin.breadcrumb.dealer_info'
        }
      ],
      template: '<admin-organisation-dealer-info-page></admin-organisation-dealer-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-organisation-dealers.module" */ "./dealer-info/admin-organisation-dealer-info.module");
      }
    })

    .segment('organisation-services', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.organisations',
          url: '/admin/organisations'
        },
        {
          label: 'admin.breadcrumb.organisation_info'
        }
      ],
      template: '<admin-organisation-services-page></admin-organisation-services-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-organisations-services.module" */ "./services/admin-organisations-services.module");
      }
    })

  ;
}
